import type { Selection } from "../domain/types";
import {
  isEmailBuilderFormFieldTarget,
  isEmailBuilderTextEditableTarget,
} from "./emailBuilderHistoryHotkeys";

export function isEmailBuilderSidePanelTarget(target: EventTarget | null): boolean {
  return target instanceof Element && target.closest("[data-editor-region]") !== null;
}

export function isEmailBuilderCanvasKeyboardTarget(target: EventTarget | null): boolean {
  return (
    target instanceof Element &&
    (target.closest("#main-canvas") !== null ||
      target.closest("#email-builder-main") !== null)
  );
}

export function shouldHandleEmailBuilderCanvasKeys(
  target: EventTarget | null,
  selection: Selection,
): boolean {
  if (
    isEmailBuilderFormFieldTarget(target) ||
    isEmailBuilderTextEditableTarget(target) ||
    isEmailBuilderSidePanelTarget(target)
  ) {
    return false;
  }

  return isEmailBuilderCanvasKeyboardTarget(target) || selection.kind !== "email";
}

export function shouldSkipEmailBuilderCanvasHotkeysForTarget(
  target: EventTarget | null,
): boolean {
  return isEmailBuilderFormFieldTarget(target) || isEmailBuilderTextEditableTarget(target);
}

export function shouldPreventEmailBuilderTextEditableBrowserShortcutLeak(
  event: Pick<KeyboardEvent, "key" | "ctrlKey" | "metaKey" | "shiftKey">,
): boolean {
  if (!event.metaKey && !event.ctrlKey) {
    return false;
  }

  const key = event.key.toLowerCase();
  if (key === "d") {
    return true;
  }

  if (key === "z") {
    return true;
  }

  return event.ctrlKey && !event.metaKey && key === "y" && !event.shiftKey;
}

export function shouldBlurEmailBuilderPanelFieldOnEscape(
  target: EventTarget | null,
): boolean {
  return isEmailBuilderFormFieldTarget(target) && isEmailBuilderSidePanelTarget(target);
}

export type TEmailBuilderCanvasReorderHotkeyAxis = "vertical" | "horizontal";

export function resolveEmailBuilderCanvasReorderHotkeyDirection(
  event: Pick<KeyboardEvent, "key" | "altKey" | "shiftKey" | "ctrlKey" | "metaKey">,
  axis: TEmailBuilderCanvasReorderHotkeyAxis = "vertical",
): -1 | 1 | null {
  if (!event.altKey || !event.shiftKey || event.ctrlKey || event.metaKey) {
    return null;
  }

  if (axis === "horizontal") {
    if (event.key === "ArrowLeft") {
      return -1;
    }

    if (event.key === "ArrowRight") {
      return 1;
    }

    return null;
  }

  if (event.key === "ArrowUp") {
    return -1;
  }

  if (event.key === "ArrowDown") {
    return 1;
  }

  return null;
}
